import { createContext, useContext } from "react";

export const AppLayoutTitleContext = createContext(false);

export function useAppLayoutTitleContext() {
  return useContext(AppLayoutTitleContext);
}
